import { useEffect, useState } from "react";
import ModuleTextInput from "./ModuleTextInput";

const ModuleNumericalInput = (props) => {
    return (
        <ModuleTextInput
            {...props}
            type={props.enabled ? "number" : "text"}
        />
    );
}

export default ModuleNumericalInput;
